class ResultFormatterBase{
    format(result){
        return result;
    }
}

export default ResultFormatterBase;